<template>
  <div class="leaderboard-box">
    <div class="indicators">
      <div
        class="status"
        v-for="(item, index) in status"
        :key="index"
        :class="item.isActive && 'is-active'"
        @click="changeStatus(item.value)"
      >
        {{ $t(`personal.referrals.leaderboard.status.${item.value}`) }}
      </div>
    </div>
    <div class="list-item self">
      <div class="list-left">
        <span v-show="selfInfo.index > 0" class="index">{{ formatIndex(selfInfo.index) }}</span>
      </div>
      <div class="list-right">
        <div>
          <div class="photo">
            <img
                :src="$DjangoMediaUrl(selfInfo.photo_url)"
                :title="selfInfo.name"
                @error="getDefaultProfilePhoto($event)"
              >
          </div>
          <span class="name">{{ selfInfo.name }}</span>
        </div>
        <span>{{ formatCount(selfInfo.count) }}</span>
      </div>
    </div>
    <div
      class="list-item"
      v-for="(item, index) in leaderboardList"
      :key="index"
    >
      <div class="list-left">
        <span class="index">{{ formatIndex(item.index) }}</span>
      </div>
      <div class="list-right">
        <div>
          <div class="photo">
            <img
                :title="item.name"
                :src="$DjangoMediaUrl(item.photo_url)"
                @error="getDefaultProfilePhoto($event)"
              >
          </div>
          <span class="name">{{ item.name }}</span>
        </div>
        <span>{{ formatCount(item.count) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { padStart } from 'lodash'

export default {
  components: {

  },
  data () {
    return {
      select: 'applied',
      status: [
        // { value: 'shares', isActive: false },
        { value: 'views', isActive: false },
        { value: 'submits', isActive: false },
        { value: 'applied', isActive: true },
        { value: 'interviewed', isActive: false },
        { value: 'onboard', isActive: false },
        { value: 'probation', isActive: false },
        { value: 'all', isActive: false }
      ],
      leaderboardList: [],
      selfInfo: []
    }
  },
  created () {
    this.initData()
  },
  mounted () {

  },
  methods: {
    ...mapActions('personal', ['getMyLeaderBoardData']),
    initData () {
      this.getLeaderBoardData()
    },
    async getLeaderBoardData () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getMyLeaderBoardData({ status: this.select })
        if (resp) {
          this.leaderboardList = resp.list
          this.selfInfo = resp.self
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    formatCount (data) {
      data = data + ''
      const reg = /(?=(?!\b)(?:\d{3})+(?!\d))/g
      if (data) {
        return data.trim().replace(reg, ',')
      }
      return data
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    },
    changeStatus (status) {
      this.select = status
      this.status.forEach(item => {
        if (item.value !== status) {
          item.isActive = false
        } else {
          item.isActive = true
        }
      })
      this.getLeaderBoardData()
    },
    formatIndex (index) {
      return padStart(index, '2', '0')
    }
  }
}
</script>

<style lang="scss" scoped>
.leaderboard-box {
  background-color: #FFFFFF;
  padding-top: 5px;
  border-radius: 5px;

  .indicators {
      display: flex;
      padding: 10px;
      margin-bottom: 10px;
      font-size: 12px;
      border-bottom: 1px solid #ddd;
      justify-content: space-around;

      .status {
        padding: 5px 10px;
        border: 1px solid #dddddd;
        text-align: center;
        cursor: pointer;
        word-break: keep-all;
        white-space: nowrap;

        &:hover, &.is-active {
          background: #aaaaaa;
          color: #ffffff;
          transition-duration: .3s;
        }

        div {
          white-space: nowrap;
        }
      }
  }

  .list-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-left: 3px solid #ffffff;

    .list-left {
      width: 7%;

      .index {
        width: 20px;
      }

      > span {
        padding-left: 10px;
      }
    }

    .list-right {
      display: flex;
      width: 90%;
      height: 40px;
      justify-content: space-between;
      padding-right: 20px;
      border-bottom: 1px solid #d6d6d6;
      align-items: center;

      > div {
        display: flex;
        align-items: center;

        > span {
            padding-left: 10px;
        }
      }
    }

    .photo {
      padding-top: 5px;

      > img {
        width: 25px;
        height: 25px;
        border-radius: 50%;
      }
    }
  }

  .self {
    border-left: 3px solid rgb(233, 110, 9);
    background-color: #fef9f5;
  }
}
</style>
